import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import NewAssessmentType from "./Type/NewType";
import AssessmentTypeList from "./Type/ListType";
import { NEW_TYPE, GET_TYPES, UPDATE_TYPE, UPDATE_CATEGORY, NEW_CATEGORY } from "../../../queries/assessment.query";
import auth from "../../../providers/Auth.Provider";
import AlertMessage from "../../../partials/alertMessage";
import LoadingSpinner from "../../../partials/loading";
import UpdateAssessmentType from "./Type/UpdateType";
import { useMutation, useQuery } from "@apollo/react-hooks";

const Assessment = ({ match }) => {
    // local state
    const [type, setType] = useState(null);
    const [category, setCategory] = useState(null);

    const [update, setUpdate] = useState(false);
    const [updateCategory, setUpdateCategory] = useState(false);

    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { site } = GetToken() && GetAuthenticatedStaff();
    const title = "Assessment Type and Category";

    // prepare query
    const { loading: typeLoading, data: typeData, error: typeError } = useQuery(GET_TYPES, { variables: { site: site && site.id } });
    //  New category mutation
    const [CreateNewCategory, { loading: newCategoryLoading, error: newCategoryError, data: newCategoryData }] = useMutation(NEW_CATEGORY, {
        update(caches, { data: { NewAssessmentCategory } }) {
            const { GetAssessmentCategories } = caches.readQuery({
                variables: { site: site && site.id },
                query: GET_TYPES,
            });
            // Update cache
            GetAssessmentCategories.docs.unshift(NewAssessmentCategory.doc);
            // write back the update
            caches.writeQuery({
                variables: { site: site && site.id },
                data: { GetAssessmentCategories },
                query: GET_TYPES,
            });
        },
    });
    //  New type mutation
    const [CreateNewType, { loading: newLoading, error: newError, data: newData }] = useMutation(NEW_TYPE, {
        update(caches, { data: { NewAssessment } }) {
            const { GetAssessments } = caches.readQuery({
                variables: { site: site && site.id },
                query: GET_TYPES,
            });
            // Update cache
            GetAssessments.docs.unshift(NewAssessment.doc);
            // write back the update
            caches.writeQuery({
                variables: { site: site && site.id },
                data: { GetAssessments },
                query: GET_TYPES,
            });
        },
    });

    // Update type mutation
    const [updateTypeFunction, { loading: updateTypeLoading, error: updateTypeError }] = useMutation(UPDATE_TYPE);

    // Update category mutation
    const [updateCategoryFunction, { loading: updateCategoryLoading, error: updateCategoryError }] = useMutation(UPDATE_CATEGORY);

    // return function
    return (
        <>
            <Helmet>
                {title} | {appName}
            </Helmet>

            <div className="row justify-content-center">
                <div className="col-md-6 m-b-20 fade-in">
                    {update && (
                        <div className="card fade-in">
                            <div className="card-head">
                                <header>
                                    <span className="text-muted">Update</span> {type.name}
                                </header>
                            </div>
                            <div className="card-body">
                                {updateTypeLoading && <LoadingSpinner loading={updateTypeLoading} />}
                                <AlertMessage message={updateTypeError && updateTypeError.message} failed={true} />
                                <UpdateAssessmentType
                                    title="Type"
                                    onCancel={() => setUpdate(false)}
                                    onSubmit={async ({ name, icon }) => {
                                        await updateTypeFunction({
                                            variables: {
                                                id: type.id,
                                                name,
                                                icon,
                                            },
                                        });
                                        setUpdate(false);
                                    }}
                                    currentValue={type.name}
                                    icon={type.icon}
                                />
                            </div>
                        </div>
                    )}
                    <div className="card">
                        <div className="card-head">
                            <header>Assessment Type</header>
                            <div className="tools">
                                <a className="t-collapse btn-color fa fa-chevron-down" href="javascript:;"></a>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <h5>New Type:</h5>
                                    {newLoading && <LoadingSpinner loading={newLoading} />}
                                    <AlertMessage message={newData && newData.NewAssessment.message} F />
                                    <AlertMessage message={newError && newError.message} failed={true} />

                                    <NewAssessmentType
                                        title="Type"
                                        onSubmit={async ({ name, icon, general }) => {
                                            await CreateNewType({
                                                variables: {
                                                    site: site.id,
                                                    name,
                                                    icon,
                                                    general,
                                                },
                                            });
                                        }}
                                    />
                                </div>
                                <div className="col-md-12">
                                    {typeLoading && <LoadingSpinner loading={typeLoading} />}
                                    <AlertMessage message={typeError && typeError.message} failed={true} />
                                    {!typeLoading && (
                                        <>
                                            <hr />
                                            <h5>Assessment Type List:</h5>
                                            <AssessmentTypeList
                                                title="Type"
                                                onSelect={(item) => {
                                                    setType(item);
                                                    setUpdate(true);
                                                    document.body.scrollTop = 0;
                                                    document.documentElement.scrollTop = 0;
                                                }}
                                                items={typeData && typeData.GetAssessments.docs}
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!typeLoading && (
                    <div className="col-md-6 fade-in">
                        {updateCategory && (
                            <div className="card fade-in">
                                <div className="card-head">
                                    <header>
                                        <span className="text-muted">Update</span> {category.name}
                                    </header>
                                </div>
                                <div className="card-body">
                                    {updateCategoryLoading && <LoadingSpinner loading={updateCategoryLoading} />}
                                    <AlertMessage message={updateCategoryError && updateCategoryError.message} failed={true} />
                                    <UpdateAssessmentType
                                        title="Category"
                                        onCancel={() => setUpdateCategory(false)}
                                        onSubmit={async (name) => {
                                            await updateCategoryFunction({
                                                variables: {
                                                    id: category.id,
                                                    name,
                                                },
                                            });
                                            setUpdateCategory(false);
                                        }}
                                        currentValue={category.name}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="card">
                            <div className="card-head">
                                <header>Assessment Category</header>
                                <div className="tools">
                                    <a className="t-collapse btn-color fa fa-chevron-down" href="javascript:;"></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5>New Category</h5>
                                        {newCategoryLoading && <LoadingSpinner loading={newCategoryLoading} />}
                                        <AlertMessage message={newCategoryData && newCategoryData.NewAssessmentCategory.message} failed={false} />
                                        <AlertMessage message={newCategoryError && newCategoryError.message} failed={true} />
                                        <NewAssessmentType
                                            title="Category"
                                            onSubmit={async ({ name }) => {
                                                await CreateNewCategory({
                                                    variables: {
                                                        name,
                                                        site: site.id,
                                                    },
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        {!typeLoading && (
                                            <>
                                                <hr />
                                                <h5>Assessment Category List:</h5>
                                                <AssessmentTypeList
                                                    className="fade-in"
                                                    title="Category"
                                                    onSelect={(item) => {
                                                        setCategory(item);
                                                        setUpdateCategory(true);
                                                        document.body.scrollTop = 0;
                                                        document.documentElement.scrollTop = 0;
                                                    }}
                                                    items={typeData && typeData.GetAssessmentCategories.docs}
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Assessment;
